import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const parkingsApi = createApi({
  reducerPath: 'parkingsApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkings'],
  endpoints: (builder) => ({
    findAllServiceDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingSpaceLocationController.findAllServiceDetail,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getAllParkingSpaceLocation: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingSpaceLocationController.getAllParkingSpaceLocation,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findParkingSpaceLocationById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.parkingSpaceLocationController.findParkingSpaceLocationById}${body.id}/${body.customerId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    saveParkingSpaceLocation: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? spotFinder.parkingSpaceLocationController.updateParkingSpaceLocation
            : body.payload.isConform
            ? spotFinder.parkingSpaceLocationController.updateParkingSpaceLocation
            : spotFinder.parkingSpaceLocationController.saveParkingSpaceLocation,
          method: body.payload.isEdit ? 'PUT' : body.payload.isConform ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateParkingSpaceLocation: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingSpaceLocationController.updateParkingSpaceLocation,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteParkingSpaceLocationById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.parkingSpaceLocationController.deleteParkingSpaceLocationById}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    uploadParkingImages: builder.mutation({
      query(body) {
        return {
          url: `/parkingSpaceLocation/${body.parkingLocationId}/${body.docType}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllServiceDetailMutation,
  useFindParkingSpaceLocationByIdMutation,
  useGetAllParkingSpaceLocationMutation,
  useSaveParkingSpaceLocationMutation,
  useUpdateParkingSpaceLocationMutation,
  useDeleteParkingSpaceLocationByIdMutation,
  useUploadParkingImagesMutation,
} = parkingsApi;
